// Kundcitat som visas på start- och TGA-sidan. Källa: kundberättelserna i
// src/pages/TGAKundberattelser.tsx (samma formuleringar, sv + en).

export interface CustomerQuote {
  id: "eidra" | "stockwik" | "crown-energy" | "crown-energy-analys";
  name: string;
  initials: string;
  role: { sv: string; en: string };
  text: { sv: string; en: string };
}

export const customerQuotes: CustomerQuote[] = [
  {
    id: "eidra",
    name: "John Sandvall",
    initials: "JS",
    role: {
      sv: "Head of group finance and reporting, Eidra",
      en: "Head of group finance and reporting, Eidra",
    },
    text: {
      sv: "Vi bygger våra egna rapporter i Excel. Det gör att vi kan forma analyser efter mottagaren – snabbt och effektivt. Systemet begränsar oss inte.",
      en: "We build our own reports in Excel. That lets us shape analyses for the audience – quickly and efficiently. The system does not limit us.",
    },
  },
  {
    id: "stockwik",
    name: "Andreas Säfstrand",
    initials: "AS",
    role: { sv: "CFO, Stockwik", en: "CFO, Stockwik" },
    text: {
      sv: "Möjligheten att göra egna analyser utan att kontakta varje bolag är en stor fördel. Det sparar tid – och ger en bättre överblick.",
      en: "The ability to do our own analyses without contacting each company is a big advantage. It saves time – and gives a better overview.",
    },
  },
  {
    id: "crown-energy",
    name: "Michail Shatkus",
    initials: "MS",
    role: { sv: "CFO, Crown Energy", en: "CFO, Crown Energy" },
    text: {
      sv: "Vi rekommenderar Tiego till bolag med internationell verksamhet. Det är flexibelt och kraftfullt – och vi får stöd från konsulter som förstår både systemet och redovisningen.",
      en: "We recommend Tiego to companies with international operations. It is flexible and powerful – and we get support from consultants who understand both the system and the accounting.",
    },
  },
  {
    id: "crown-energy-analys",
    name: "Michail Shatkus",
    initials: "MS",
    role: { sv: "CFO, Crown Energy", en: "CFO, Crown Energy" },
    text: {
      sv: "Vi kan analysera på flera nivåer, göra drill-downs, och få enhetliga rapporter oavsett vilket land datan kommer från. Alla jobbar i samma format – det är en stor fördel.",
      en: "We can analyze at multiple levels, drill down, and get consistent reports regardless of which country the data comes from. Everyone works in the same format – that is a big advantage.",
    },
  },
];

export const quotesById = (ids: CustomerQuote["id"][]) =>
  ids.map((id) => customerQuotes.find((q) => q.id === id)!).filter(Boolean);
